<template>
  <div
    ref="mainForm"
    class="main-config-form scroll_bar_beautify_ff"
  >
    <a-form
      v-if="confrimConfig"
      :form="form"
      class="config-form"
      :class="{'en-config-form': getLang() === 'en'}"
      @submit.prevent="handleSubmit"
    >
      <my-editor
        :data="tipAfterData"
        :toolbar-items="toolbarItems"
        class="tips_after_submit"
        @change="changeTextarea"
      />
      <a-form-item
        label=" "
        class="link-item"
      >
        <div class="link">
          <a-checkbox
            :checked="confrimConfig.is_redirect ? true : false"
            @change="onChangeIsLink"
          >
            {{ $t('message["1440"]') }}
          </a-checkbox>
          <a-input
            v-decorator="['redirect_url', {
              rules: [{
                required: !!confrimConfig.is_redirect, message: redirectUrlPlace
              }],
              initialValue: confrimConfig.redirect_url,
              preserve: true
            }]"
            :placeholder="redirectUrlPlace"
            @change="handleChangeRedirectUrl"
          />
        </div>
      </a-form-item>

      <my-select
        :value="confrimConfig.language"
        :data="languages"
        :placeholder="selectPlaceholder"
        @change="handleChangeLanguage"
      />

      <div class="dev-member">
        <my-cascader
          :data="{
            fieldkey: 'dev',
            fieldname: developerTitTxt,
            isneeded: permissions['form-manager-self'] && !permissions['form-manager-public'] && !permissions['form-manager-all'],
            fieldvalue: selectDev
          }"
          :value="selectDev"
          :get-data="getDevMembers"
          @change="handleChangeDev"
        >
          <config-tooltip :text="configDevelopTip" />
        </my-cascader>
      </div>
      <a-form-item
        v-if="noticeMember && noticeMember.length"
        :label="`${subNoticeTit}：`"
        class="notice-member"
      >
        <a-select
          v-model="confrimConfig.notice_userid"
          mode="multiple"
          :placeholder="selectEnPlaceholder"
          @change="handleChangeNoticeMember"
        >
          <a-select-option
            v-for="item in noticeMember"
            :key="item.userid"
          >
            {{ item.truename }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <div class="line" />

      <div
        v-if="confrimConfig.form_config"
        class="from-info"
      >
        <!-- 接待方式 -->
        <div
          v-if="receptionInfo && receptionInfo.child && receptionInfo.child[0]"
          class="reception-info"
        >
          <my-cascader
            :value="selectReception"
            :data="receptionInfo.child[0]"
            @change="handleChangeReception"
          >
            <config-tooltip :text="$t('message[1754]')" />
          </my-cascader>
        </div>
        <my-select
          :value="confrimConfig.form_config.from_type"
          :data="fromInfo"
          :placeholder="refferPlaceholder"
          @change="handleChangeFrom"
        >
          <config-tooltip :text="configRefferTip" />
        </my-select>
        <div
          v-if="fromOtherOptions.length"
          class="child-config"
        >
          <h2>{{ $t('message["1081"]') }}：</h2>
          <a-checkbox-group
            :value="confrimConfig.form_config.from_other"
            @change="onChangeFromOther($event, 'from_other')"
          >
            <a-checkbox
              v-for="item in fromOtherOptions"
              :key="item.fieldkey"
              :value="item.fieldkey"
            >
              {{ item.fieldname }}
            </a-checkbox>
          </a-checkbox-group>
        </div>
        <div
          v-if="showIpCheckbox"
          class="child-config"
        >
          <h2>{{ $t('message["1085"]') }}：</h2>
          <a-checkbox-group
            v-if="fromIpOptions.length"
            :value="confrimConfig.form_config.w_from"
            @change="onChangeFromOther($event, 'w_from')"
          >
            <a-checkbox
              v-for="item in fromIpOptions"
              :key="item.fieldkey"
              :value="item.fieldkey"
            >
              {{ item.fieldname }}
            </a-checkbox>
          </a-checkbox-group>
          <a-checkbox-group
            v-if="ipInfo['w_submit'] && $toType(ipInfo['w_submit']) === 'object'"
            :value="confrimConfig.form_config.w_submit"
            @change="onChangeFromOther($event, 'w_submit')"
          >
            <a-checkbox
              v-for="(item, key) in ipInfo['w_submit']"
              :key="key"
              :value="key"
            >
              {{ item.fieldname }}
            </a-checkbox>
          </a-checkbox-group>
        </div>
      </div>
      <a-form-item
        v-if="confrimConfig.form_config"
        :label="`${subLimitTit}：`"
        class="limit-item"
      >
        <span
          v-decorator="['once_limit', {
            rules: [{
              validator: checkOnceLimit,
              message: onceLimitPlace
            }],
            initialValue: confrimConfig.form_config.once_limit == '0' ? '' : confrimConfig.form_config.once_limit
          }]"
          class="wrap"
        >
          <a-input
            :value="confrimConfig.form_config.once_limit == '0' ? '' : confrimConfig.form_config.once_limit"
            :placeholder="enterPlaceholder"
            @change="handleChangeOnceLimit"
          />
        </span>
        {{ $t('message["305"]') }}
      </a-form-item>
      <div
        v-if="baseInfo.child && confrimConfig.form_config"
        class="base-info"
      >
        <my-select
          v-for="(item) in baseInfo.child"
          :id="item.fieldkey"
          :key="item.fieldkey"
          :value="confrimConfig.form_config[item.fieldkey]"
          class="clearfix"
          :data="item"
          :modules-data="baseInfo"
          :placeholder="selectEnPlaceholder + item.fieldname"
          @change="handleChangeBaseInfoItem($event, item)"
        >
          <config-tooltip :text="configTTip + item.fieldname" />
        </my-select>
      </div>
    </a-form>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { getMyAuthTeamInfo, getAuthTeamInfo } from '@/services/index'
import { getAuthUsersListByPk } from '@/services/universalForm'
import MyCascader from '@/pc/inquery/formItem/Cascader'
import MySelect from '@/pc/inquery/formItem/Select'
import MyEditor from '@/pc/inquery/formItem/Editor'
import ConfigTooltip from './ConfigTooltip'
import { getH } from '@/store/universalForm/convert'
import { getLang } from '@/lib/storage'

export default {
  components: {
    MyCascader,
    MySelect,
    ConfigTooltip,
    MyEditor
  },

  props: {
    permissions: {
      type: Object,
      default: () => ({})
    }
  },

  provide () {
    return {
      myForm: this.form
    }
  },

  data () {
    return {
      form: this.$form.createForm(this),
      devMemberList: [],
      noticeMember: [],
      selectDev: [],
      selectReception: [],
      toolbarItems: ['font', 'size', 'bold', 'italic', 'underline', 'color', 'background', 'link']
    }
  },

  computed: {
    ...mapState('universalForm/outform', ['formData', 'confrimConfig', 'fromOtherOptions', 'fromIpOptions', 'configFormError', 'compareFieldError', 'result']),
    fromInfo () {
      if (!this.formData) return
      const { from_info: fromInfo = {} } = this.formData.deploy || {}
      fromInfo.options = fromInfo.child
      fromInfo.isneeded = 1
      fromInfo.fieldvalue = this.confrimConfig.form_config.from_type
      return fromInfo
    },
    receptionInfo () {
      if (!this.formData) return
      const { reception_info: receptionInfo = {} } = this.formData.deploy || {}
      if (receptionInfo.child && receptionInfo.child[0]) {
        receptionInfo.child[0].isneeded = 0
      }

      return receptionInfo
    },
    ipInfo () {
      if (!this.formData) return
      const { ip_info: ipInfo = {} } = this.formData.deploy || {}
      return ipInfo
    },
    baseInfo () {
      if (!this.formData) return
      let { base_info: baseInfo = {} } = this.formData.deploy || {}
      baseInfo.child && baseInfo.child.forEach(item => {
        if (item.fieldkey === 'base_info.info_type' && item.options.length > 0) {
          item.options = item.options.filter(item2 => item2.visibletype !== 2)
        }
        item.isneeded = 0
      })
      return baseInfo
    },
    languages () {
      if (!this.formData) return
      const { languages = {}, config = {} } = this.formData.deploy || {}
      let arr = []
      for (let key in languages) {
        arr.push({
          fieldkey: key * 1,
          id: key * 1,
          name: languages[key]
        })
      }
      return {
        fieldkey: 'errorLanguages',
        fieldname: this.$t('message["135"]'),
        fieldvalue: config.language === '' ? undefined : config.language,
        options: arr,
        isneeded: 1,
        placeholder: this.$t('message["857"]')
      }
    },
    tipAfterData () {
      return Object.assign({}, {
        fieldvalue: this.confrimConfig && this.confrimConfig.tips_after_submit,
        fieldkey: 'tips_after_submit',
        fieldname: this.$t('message["1164"]'),
        isneeded: 1
      })
    },
    showIpCheckbox () {
      if (!this.fromIpOptions.length && this.$toType(this.ipInfo && this.ipInfo['w_submit']) === 'array') {
        return false
      }
      return true
    },
    developerTitTxt () {
      return this.$t('message["549"]')
    },
    redirectUrlPlace () {
      return this.$t('message["810"]')
    },
    onceLimitPlace () {
      return this.$t('message["837"]')
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    },
    selectPlaceholder () {
      return this.$t('message["857"]')
    },
    refferPlaceholder () {
      return this.$t('message["887"]')
    },
    selectEnPlaceholder () {
      return this.$t('message["855"]')
    },
    subNoticeTit () {
      return this.$t('message["1171"]')
    },
    subLimitTit () {
      return this.$t('message["1172"]')
    },
    configTTip () {
      return this.$t('message["1209"]')
    },
    configRefferTip () {
      return this.$t('message["1210"]')
    },
    configDevelopTip () {
      return this.$t('message["1211"]')
    }
  },

  watch: {
    confrimConfig: {
      handler (val, oVal) {
        if (!val) return
        this.selectDev = this.setDefaultValue({
          info: {
            roleid: this.confrimConfig.dev_roleid,
            groupid: this.confrimConfig.dev_groupid,
            userid: this.confrimConfig.dev_userid
          }
        })
        // 接待方式默认值
        let { form_config: formConfig = {} } = this.confrimConfig || {}
        this.selectReception = formConfig['reception_info.reception_type'] || []

        if (val.dev_userid !== this.confrimConfig.dev_userid || (val.dev_userid && oVal && !oVal.dev_userid)) {
          this.getAllLeaderByUserid(this.confrimConfig.dev_userid)
        }
        if (this.confrimConfig.form_config && this.confrimConfig.form_config.from_type === 0 && this.fromInfo.options) {
          this.confrimConfig.form_config.from_type = this.fromInfo.options[0].id
        }
      },
      immediate: true,
      deep: true
    }
  },

  mounted () {
    this.selectDev = this.setDefaultValue({
      info: {
        roleid: this.confrimConfig.dev_roleid,
        groupid: this.confrimConfig.dev_groupid,
        userid: this.confrimConfig.dev_userid
      }
    })

    this.getAllLeaderByUserid(this.confrimConfig.dev_userid)

    this.$nextTick(() => {
      let $main = this.$refs.mainForm
      getH($main, 160)
    })
  },

  methods: {
    ...mapMutations('universalForm/outform', ['setConfrimConfig', 'setFromOtherOptions', 'setConfigFormError']),
    getLang,
    async getDevMembers () {
      let params = {
        pk: 'inquiry-dev',
        isshowlevel: 1
      }
      let isneeded = this.permissions['form-manager-self'] && !this.permissions['form-manager-public'] && !this.permissions['form-manager-all']
      let result
      if (isneeded) { // 如果这里是必填： 自己所管理的人和自己
        result = await getMyAuthTeamInfo().params(params).fetch()
      } else { // 如果这里是非必填：开发人员可选全部有信息开发权限的人员
        result = await getAuthTeamInfo().params(params).fetch()
      }
      let { payload: data = [] } = (result && result.data) || {}
      this.setGroupEmpty(data)
      this.setRoleEmpty(data)
      return data
    },
    setGroupEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        if (item.keyname === 'groupid' && (!item.children || !item.children.length)) {
          data.splice(i, 1)
        }
        if (item.keyname === 'roleid' && (item.children && item.children.length)) {
          this.setGroupEmpty(item.children)
        }
      }
    },
    setRoleEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        if (item.keyname === 'roleid' && (!item.children || !item.children.length)) {
          data.splice(i, 1)
        }
      }
    },
    async getAllLeaderByUserid (userid) {
      let params = {
        userid,
        pk: 'form-submit-history-all'
        // isshowlevel: 1
      }
      await getAuthUsersListByPk()
        .onSuccess(res => {
          this.noticeMember = res
        })
        .params(params)
        .fetch()
    },
    changeTextarea (value) {
      this.confrimConfig.tips_after_submit = value
    },
    onChangeIsLink (e) {
      this.confrimConfig.is_redirect = e.target.checked ? 1 : 0
      this.$nextTick(() => {
        this.form.validateFields(['redirect_url'], { force: true })
      })
    },
    handleChangeRedirectUrl (e) {
      let val = e.target.value
      this.confrimConfig.redirect_url = val
    },
    handleChangeLanguage (value) {
      this.confrimConfig.language = value
    },
    handleChangeReception (data = {}) {
      this.selectReception = data.value
      this.confrimConfig.form_config['reception_info.reception_type'] = this.selectReception
    },
    handleChangeDev (data) {
      // console.log(data)
      this.confrimConfig.dev_roleid = data.info.roleid
      this.confrimConfig.dev_groupid = data.info.groupid
      this.confrimConfig.dev_userid = data.info.userid

      this.selectDev = this.setDefaultValue(data)

      this.confrimConfig.notice_userid = []
      if (data.info.userid) {
        this.getAllLeaderByUserid(data.info.userid)
      }
    },
    /**
     * 处理默认value值
     */
    setDefaultValue (item = {}) {
      let arr = []
      const { info = {} } = item
      const { roleid = 0, groupid = 0, userid = 0 } = info

      arr = []
      if (parseInt(roleid)) {
        arr.push(`${roleid}-roleid`)
      }
      if (parseInt(groupid)) {
        arr.push(`${groupid}-groupid`)
      }
      if (parseInt(userid)) {
        arr.push(`${userid}-userid`)
      }
      return arr
    },
    handleChangeFrom (value) {
      this.confrimConfig.form_config.from_type = value

      this.setFromOtherOptions(value)
    },
    onChangeFromOther (value, type) {
      this.confrimConfig.form_config[type] = value
      // this.$set(this.confrimConfig.form_config, type, value)
    },
    handleChangeOnceLimit (e) {
      let val = e.target.value
      val = val.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[a-z]|e/gi, '')
      this.confrimConfig.form_config.once_limit = val
    },
    checkOnceLimit (rule, value, callback) {
      let fieldvalue = value
      if (fieldvalue === '') {
        callback()
        return
      }
      if (!/^(?:0|-?(?:0\.\d*[1-9]|[1-9]\d*(?:\.\d*[0-9])?))$/.test(value)) { // 是数字，包含正负和小数
        rule.message = this.$t('message["805"]')
        callback(rule.message)
        return
      }
      // 禁止负数
      if (!/^(?:0|[1-9]\d*)(?:\.\d*[0-9])?$/.test(value)) {
        rule.message = this.$t('message["836"]')
        callback(rule.message)
        return
      }

      // 禁止小数点
      if (!/^(?:0|-?[1-9]\d*)$/.test(value)) {
        rule.message = this.$t('message["832"]')
        callback(rule.message)
        return
      }

      callback()
    },
    handleFocusNoticeMember () {
      if (this.confrimConfig.dev_userid) {
        this.getAllLeaderByUserid(this.confrimConfig.dev_userid)
      }
    },
    handleChangeNoticeMember (value) {
      this.confrimConfig.notice_userid = value
    },
    handleChangeBaseInfoItem (value, item) {
      this.confrimConfig.form_config[item.fieldkey] = value
    },
    handleSubmit () {
      this.$nextTick(() => {
        this.setConfrimConfig(this.confrimConfig)
        this.form.validateFields(async (err, values) => {
          if (!err) {
            this.setConfigFormError(false)
          } else {
            this.setConfigFormError(true)
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.main-config-form {
  overflow-y: auto;
}
.config-form::v-deep {
  padding: 40px 24px;
  .ant-form-item-label {
    float: left;
    width: 180px;
  }
  .ant-form-item-control-wrapper {
    float: left;
  }
  .quill-editor {
    width: 640px;
    margin-bottom: 0;
  }
  .link-item {
    .ant-form-item-label {
      opacity: 0;
    }
    .ant-checkbox-wrapper {
      margin-bottom: 0;
    }
  }
  .link {
    label {
      margin-right: 8px;
    }
    .ant-input {
      width: 548px;
    }
  }
  .tooltip-btn {
    margin-left: 12px;
    color: #d6d6d6;
    cursor: pointer;
  }
  .cascader {
    .wrap {
      float: left;
    }
  }
  .line {
    margin-bottom: 24px;
    border-top: solid 1px #ebebeb;
  }
  .from-info {
    padding-bottom: 16px;
  }
  .limit-item .ant-input {
    width: 80px;
    margin-right: 6px;
  }
  .child-config {
    margin-top: 24px;
    padding-left: 180px;
    h2 {
      margin: -12px 0 8px;
      font-size: 14px;
    }
    .ant-checkbox-group {
      display: block;
    }
    .ant-checkbox-wrapper {
      // display: block;
      margin-bottom: 8px;
    }
  }
}
.en-config-form::v-deep {
  .ant-form-item-label {
    width: 210px !important;
  }
}
</style>
<style lang="scss">
.config-form {
  /* .link-item .ant-checkbox-wrapper {
    margin-bottom: 0;
  } */
}
</style>
